// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3RWbt","containerItemsCenter":"Skeleton_containerItemsCenter__2KnBe"};